import { LitElement, html } from 'lit';

import styles from './fit-fav-count.css';
import { FitStorageBehavior } from '../fit-storage/fit-storage-behavior';

class FitFavCount extends FitStorageBehavior(LitElement) {
  static get is() { return 'fit-fav-count'; }

  static get styles() { return styles; }

  render() {
    return html`
      <svg id="figure" class="faved empty" xmlns="http://www.w3.org/2000/svg" version="1.1" width="24" height="24" viewBox="0 0 24 24">
        <path id="icon" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"></path>
        <text id="count"  x="50%" y="50%" dy=".3em" font-size="16px">${this.favCount}</text>
      </svgid>`;
  }

  static get properties() {
    return {
      favCount: {
        type: Number,
        attribute: 'fav-count',
      },
    };
  }

  get storageName() {
    return 'fit-fav';
  }

  set storageValue(favList) {
    favList = favList || [];
    this.favCount = favList.length;
  }

  firstUpdated(changedProperties) {
    this.$ = {};
    this.$.figure = this.shadowRoot.querySelector('#figure');
  }

  updated(changedProperties) {
    if (changedProperties.has('favCount')) {
      this._favCountChanged(this.favCount, changedProperties.get('favCount'));
    }
  }

  _favCountChanged(newValue, oldValue) {
    this.$.figure.classList.toggle('empty', this.favCount === 0, this.$.icon);
    if (oldValue !== undefined && newValue > oldValue) {
      this.$.figure.classList.remove('changed');
      setTimeout(() => { this.$.figure.classList.add('changed'); });
    }
  }
}

customElements.define(FitFavCount.is, FitFavCount);
